import type {
  AuthResponse,
  ChangePasswordInput,
  CurrentUser,
  LoginInput,
  UpdateProfileInput,
} from '@moussenaires/shared';

import { api } from './client.js';

export const authApi = {
  login: (input: LoginInput) => api.post<AuthResponse>('/auth/login', input),
  me: () => api.get<CurrentUser>('/auth/me'),
  updateProfile: (input: UpdateProfileInput) => api.patch<CurrentUser>('/auth/me', input),
  changePassword: (input: ChangePasswordInput) => api.post<void>('/auth/me/password', input),
};
